"use client";

import { c as _c } from "react/compiler-runtime";
import { IconAlertCircle } from "@tabler/icons-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
interface Props {
  onRetry: () => void;
}
export function SearchUnavailable(t0) {
  const $ = _c(3);
  const {
    onRetry
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Alert variant="destructive" className="w-full"><IconAlertCircle /><AlertTitle>Search is temporarily unavailable</AlertTitle><AlertDescription>Please try again in a moment.</AlertDescription></Alert>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onRetry) {
    t2 = <div className="flex flex-col items-center justify-center gap-4 pt-6 pb-6" data-testid="search-unavailable">{t1}<Button variant="outline" onClick={onRetry}>Try again</Button></div>;
    $[1] = onRetry;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}